<mat-dialog-content>
  <div class="flex flex-col" *ngFor="let log of auditLogs">
    <div class="flex flex-col md:flex-row md:gap-4 pt-4 items-center">
      <span class="font-bold text-lg">Date Changed:</span>
      <span>{{ log.timeStamp | date }}</span>

      <span class="font-bold text-lg">Changed By:</span>
      <span>{{ log.userId }}</span>
    </div>
    <div class="flex flex-col pt-2 pl-4" *ngIf="!log.deleted">
      <div class="flex flex-col" *ngFor="let change of log.changes">
        <span class="font-bold">{{ change.propertyName }}</span>
        <div class="flex flex-col md:flex-row gap-2">
          <span class="pl-4">{{ change.oldValue === ''? 'Blank' : change.oldValue }}</span>
          <span class="pl-4">-></span>
          <span class="pl-4">{{ change.newValue }}</span>
        </div>
      </div>
    </div>
    <span *ngIf="log.deleted">{{log.deletedSnapshot}}</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" color="warn" (click)="close()">Close</button>
</mat-dialog-actions>
